export function getProjects({
  searchText,
  isActive,
  projectOwnerCode,
  pageNumber,
  pageSize,
}) {
  return window.axios
    .get(`/hub/v1/projects`, {
      params: { searchText, isActive, projectOwnerCode, pageNumber, pageSize },
    })
    .then((response) => response.data);
}

export function getProjectSearchParams() {
  return window.axios
    .get(`/hub/v1/projects/items`)
    .then((response) => response.data);
}

export function getProjectById(id) {
  return window.axios
    .get(`/hub/v1/projects/${id}`)
    .then((response) => response.data);
}

export function addProject({
  id,
  name,
  description,
  slug,
  baseUrl,
  projectOwnerCode,
  authenticationTypeCode,
  basicAuth,
  bearerAuth,
  customAuth,
}) {
  return window.axios
    .post(`/hub/v1/projects`, {
      id,
      name,
      description,
      slug,
      baseUrl,
      projectOwnerCode,
      authenticationTypeCode,
      basicAuth,
      bearerAuth,
      customAuth,
    })
    .then((response) => response.data);
}

export function updateProject({
  id,
  name,
  description,
  slug,
  baseUrl,
  projectOwnerCode,
  authenticationTypeCode,
  basicAuth,
  bearerAuth,
  customAuth,
}) {
  return window.axios
    .put(`/hub/v1/projects/${id}`, {
      name,
      description,
      slug,
      baseUrl,
      projectOwnerCode,
      authenticationTypeCode,
      basicAuth,
      bearerAuth,
      customAuth,
    })
    .then((response) => response.data);
}

export function changeProjectStatus({ id, isActive }) {
  return window.axios
    .put(`/hub/v1/projects/${id}/change-status`, { isActive })
    .then((response) => response.data);
}

export function checkSlugAvailability({ id, slug }) {
  return window.axios
    .get(`/hub/v1/projects/check-slug/`, { params: { id, slug } })
    .then((response) => response.data);
}

export function getProjectApis(id) {
  return window.axios
    .get(`/hub/v1/projects/${id}/apis`)
    .then((response) => response.data);
}

export function getProjectApiById({ projectId, id }) {
  return window.axios
    .get(`/hub/v1/projects/${projectId}/apis/${id}`)
    .then((response) => response.data);
}

export function addProjectApi({
  projectId,
  name,
  slug,
  description,
  httpMethodCode,
  apiUrl,
  headers,
  parameters,
  requestBody,
  responses,
}) {
  return window.axios
    .post(`/hub/v1/projects/${projectId}/apis`, {
      name,
      slug,
      description,
      httpMethodCode,
      apiUrl,
      headers,
      parameters,
      requestBody,
      responses,
    })
    .then((response) => response.data);
}

export function updateProjectApi({
  projectId,
  id,
  name,
  slug,
  description,
  httpMethodCode,
  apiUrl,
  headers,
  parameters,
  requestBody,
  responses,
}) {
  return window.axios
    .put(`/hub/v1/projects/${projectId}/apis/${id}`, {
      name,
      slug,
      description,
      httpMethodCode,
      apiUrl,
      headers,
      parameters,
      requestBody,
      responses,
    })
    .then((response) => response.data);
}

export function changeProjectApiStatus({ projectId, id, isActive }) {
  return window.axios
    .put(`/hub/v1/projects/${projectId}/apis/${id}/change-status`, {
      isActive,
    })
    .then((response) => response.data);
}

export function checkApiSlugAvailability({ id, apiId, slug }) {
  return window.axios
    .get(`/hub/v1/projects/${id}/apis/check-slug/`, {
      params: { id, apiId, slug },
    })
    .then((response) => response.data);
}

export function getProjectLogs(id) {
  return window.axios
    .get(`/hub/v1/projects/${id}/change-histories`)
    .then((response) => response.data);
}

export function getProjectApiLogs(projectId, apiId) {
  return window.axios
    .get(`/hub/v1/projects/${projectId}/apis/${apiId}/change-histories`)
    .then((response) => response.data);
}
